import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { guid } from '@/mixins/guid';
import dropsLoader from '@/mixins/components/drops-loader';
import { dynamicSetup } from '@/mixins/dynamic-setup';

export default Vue.component('data-product-store-emails', {
  template: require('./template.html'),
  name: 'data-product-store-emails',
  components: {
    dropsLoader,
  },
  computed: {
    ...mapGetters([
      'currentSite',
      'currentUser',
      'activeSiteType',
    ]),
    storeData() {
      return this.currentSite.dynamic.products;
    },
  },
  mixins: [guid, dynamicSetup],
  data() {
    return {
      loading: false,
      email: '',
      emails: [],
      duplicate: false,
      deleteEmail: false,
    };
  },
  created() {
    if (this.noDynamicData(this.activeSiteType)) {
      this.dynamicSetup(this.activeSiteType);
    }
    this.setInitialValues();
  },
  methods: {
    setInitialValues() {
      this.emails = _.clone(this.storeData.emails) || [];
    },
    saveChanges() {
      if (this.emails.includes(this.email)) {
        this.duplicate = 'That email already exists.';
        return;
      }
      if (this.email === this.storeData.storeEmail) {
        this.duplicate = 'The default store email is already included.';
        return;
      }
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.loading = true;
          const notif = {
            id: this.guid(),
            type: 'success',
            time: 2000,
            message: 'Store changes saved!',
          };
          try {
            this.emails.push(this.email);
            this.$store.dispatch('setGlobalValue', {
              item: this.currentSite.dynamic.products,
              key: 'emails',
              value: _.clone(this.emails || []),
            });
            await this.$lightning([{
              name: 'updateSiteAttr',
              payload: {
                siteId: this.currentSite._id,
                attr: 'dynamic',
                value: this.currentSite.dynamic,
              },
            }]);
            this.email = '';
            this.duplicate = false;
          } catch (e) {
            this.$log.error(e.message || e);
            notif.type = 'error';
            notif.message = e.message || e;
            await this._reportError({
              error: e,
              fn: 'saveChanges store emails',
            });
          } finally {
            this.loading = false;
            this.$store.dispatch('addNotification', notif);
          }
        }
      });
    },
    async removeEmail(email) {
      this.loading = true;
      const notif = {
        id: this.guid(),
        type: 'success',
        time: 2000,
        message: 'Store email removed!',
      };
      try {
        const index = _.findIndex(this.emails, a => a === email);
        if (index > -1) {
          this.emails.splice(index, 1);
          this.$store.dispatch('setGlobalValue', {
            item: this.currentSite.dynamic.products,
            key: 'emails',
            value: _.clone(this.emails),
          });
          await this.$lightning([{
            name: 'updateSiteAttr',
            payload: {
              siteId: this.currentSite._id,
              attr: 'dynamic',
              value: this.currentSite.dynamic,
            },
          }]);
          this.deleteEmail = false;
        }
      } catch (e) {
        this.$log.error(e.message || e);
        notif.type = 'error';
        notif.message = e.message || e;
        await this._reportError({
          error: e,
          fn: 'removeEmail store emails',
        });
      } finally {
        this.loading = false;
        this.$store.dispatch('addNotification', notif);
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/dynamic-data/store/emails/index.js